import * as React from "react";
const SvgHostRules = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.249 1a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 .75.75v7.042a.75.75 0 0 1-1.5 0V1.75h-14.5v18.5h2.937a.75.75 0 0 1 0 1.5H2.999a.75.75 0 0 1-.75-.75V1ZM16.08 12.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm2.482 5.061a3.75 3.75 0 1 0-4.963 0 5.76 5.76 0 0 0-3.155 4.047c-.224 1.11.722 1.892 1.636 1.892h8c.915 0 1.86-.783 1.637-1.892a5.76 5.76 0 0 0-3.155-4.047Zm-2.482.939a4.252 4.252 0 0 0-4.166 3.405l-.001.013v.003c0 .001.004.01.015.021a.212.212 0 0 0 .152.058h8c.074 0 .127-.03.153-.058a.06.06 0 0 0 .014-.021v-.016a4.252 4.252 0 0 0-4.167-3.405ZM6 4.25a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5h-9.5ZM5.249 8a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgHostRules;
